import { render, staticRenderFns } from "./GiorgiocasaLogo.vue?vue&type=template&id=31b76229&scoped=true&"
var script = {}
import style0 from "./GiorgiocasaLogo.vue?vue&type=style&index=0&id=31b76229&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b76229",
  null
  
)

export default component.exports